// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","button-text":"Button_button-text__doYTt","button-white":"Button_button-white__8-Y8O"};